import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import ProductMediaFields, { saveProductMedia } from './ProductMediaFields';
import { productsApi } from './api';
const empty = { name: '', familyCode: '', brand: '', category: '', cost: '', price: '' };
function cents(value) {
    if (value === '') return null;
    if (!/^\d+(\.\d{1,2})?$/.test(value) || !Number.isSafeInteger(Math.round(Number(value) * 100))) throw new Error('Introduce importes válidos con hasta dos decimales.');
    return Math.round(Number(value) * 100);
}
export default function CreateProduct({ visible, categories, onHide, onCreated, onPersist = () => {} }) {
    const [saved, setSaved] = useState(null);
    const [image, setImage] = useState(undefined);
    const [upcs, setUpcs] = useState([]);
    const [form, setForm] = useState(empty);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => { if (visible) { setForm(empty); setError(''); setSaved(null); setImage(undefined); setUpcs([]); } }, [visible]);
    const change = (key, value) => setForm(previous => ({ ...previous, [key]: value }));
    async function save(event) {
        event.preventDefault();
        if (saving) return;
        setError('');
        let persisted = saved;
        const progress = product => { persisted = product; setSaved(product); onPersist(product); };
        try {
            const data = { name: form.name.trim(), familyCode: form.familyCode.trim(), brand: form.brand.trim(), category: form.category || '', costCents: cents(form.cost), suggestedPriceCents: cents(form.price) };
            if (!data.name) throw new Error('El nombre del producto es obligatorio.');
            setSaving(true);
            if (!persisted) progress(await productsApi('', { method: 'POST', data }));
            onCreated(await saveProductMedia(persisted, { image, upcs }, productsApi, progress));
        } catch (e) { setError(persisted ? `El producto ya está creado. ${e.message} Corrige y reintenta para completar los datos pendientes.` : e.message); } finally { setSaving(false); }
    }
    return <Dialog header="Crear producto" visible={visible} onHide={() => !saving && onHide()} className="product-create-dialog" style={{ width: '76rem', maxWidth: '96vw' }} footer={<div className="product-create-actions">
        <Button label="Cancelar" type="button" className="p-button-text" disabled={saving} onClick={onHide} />
        <Button label="Guardar producto" type="submit" form="product-create-form" loading={saving} disabled={saving} />
    </div>}>
        <form id="product-create-form" className="product-create-form" onSubmit={save}>
            {error && <p role="alert">{error}</p>}
            <div className="product-create-columns">
            <fieldset disabled={saving || Boolean(saved)} className="product-create-basic">
            <legend>Datos del producto</legend>
            <label className="product-create-wide">Nombre<InputText aria-label="Nombre del producto" required maxLength={250} value={form.name} onChange={e => change('name', e.target.value)} /></label>
            <label>Código comercial<InputText aria-label="Código comercial" placeholder="Ej. 010#" maxLength={100} value={form.familyCode} onChange={e => change('familyCode', e.target.value)} /><small>Opcional. Puede compartirse entre productos de una misma familia.</small></label>
            <label>Marca<InputText aria-label="Marca del producto" maxLength={150} value={form.brand} onChange={e => change('brand', e.target.value)} /></label>
            <label className="product-create-wide">Categoría<Dropdown aria-label="Categoría del producto" value={form.category} options={[{ label: 'Sin categoría', value: '' }, ...categories]} onChange={e => change('category', e.value)} /></label>
            <label>Costo unitario (USD)<InputText aria-label="Costo del nuevo producto" type="number" min="0" step="0.01" value={form.cost} onChange={e => change('cost', e.target.value)} /><small>Vacío o cero se marca como «Sin costo» y no cuenta para el margen.</small></label>
            <label>Precio sugerido (USD)<InputText aria-label="Precio sugerido (USD)" type="number" min="0" step="0.01" value={form.price} onChange={e => change('price', e.target.value)} /></label>
            </fieldset>
            <ProductMediaFields image={image} upcs={upcs} onImage={setImage} onUpcs={setUpcs} disabled={saving} />
            </div>
        </form>
    </Dialog>;
}
